module.exports = __webpack_public_path__ + "img/Icon-Travel.44f0f8a6.svg";